module.exports = __webpack_public_path__ + "img/3.49aa6d5f.png";